export default {
    word1: "EBC Financial Group｜信頼と実績を誇るFX取引会社",
    word2:
      "EBC Financial Groupは、FX、指数、株式、コモディティなど、マルチアセットの金融仲介サービスを提供する、世界をリードする信頼できるFX取引会社です。",
    word3: "世界No.1のFX取引会社",
    word4: `<span class="subtitle-20_medium md-body-14_medium">100</span>カ国以上の投資家から信頼されるFX取引会社`,
    word5: "レバレッジ",
    word6: "人気銘柄",
    word7: "低スプレッド",
    word8: "国連財団のマラリア撲滅キャンペーンと提携",
    word9: "EBCコピートレードトップトレーダーの取引を無料コピー",
    word10:
      "トップトレーダーの取引シグナルを無料でコピー、シグナルは年率最大18%の報酬をゲット！",
    word11: "公正・公平",
    word12: "ワンクリックコピトレ",
    word13: "最大18%の年間管理報酬を獲得",
    word14: "リアルタイムでコピー",
    word15: `EBCとオックスフォード<br class="pc"/>大学との共催セミナー`,
    word16: "持続可能性の維持：経済成長と気候レジリエンスのバランス",
    word17: "今すぐ登録",
    word18: "詳細はこちら",
    word19: "グローバル市場で取引",
    word20:
      "機関投資家の流動性と競争力のあるスプレッドを備えた200種類以上の商品にアクセスし、優れた取引体験をお楽しみください。",
    word21: "FX",
    word22: "コモディティ",
    word23: "株価指数",
    word24: "米国株",
    word25: "ETF",
    word26: "取引銘柄",
    word27: "買値",
    word28: "売値",
    word29: "スプレッド",
    word30: "レバレッジ",
    word31: "詳細はこちら",
    word32: "87.6%以上の注文がより良い価格で約定",
    word33:
      "EBCの取引ブラックボックスは、注文アルゴリズムを正確に最適化し、価格の最適化、注文執行率、アルゴリズムの安定性において従来の取引システムよりもはるかに優れています。",
    word34: "1秒あたりの注文処理数",
    word35: "平均約定速度",
    word36: "データ通信安定率",
    word37: "最低スプレッド",
    word38: "当社の注文最適化は、業界で上位2.5%にランクされています。",
    word39: "今すぐ取引",
    word40: "安全な取引こそ、世界に信頼される",
    word41: "厳格な規制と包括的な安全対策により、すべての取引を保護します。",
    word42: "安心の総合的プロテクション",
    word43:
      "EBC は資金の安全を最優先事項と考えています。 顧客の資金はバークレイズ銀行の分離保管口座に保管されます。 金融委員会、ロイズ オブ ロンドン、AON と協力することで、EBC は包括的で多層的なセキュリティ メカニズムを確立しました。",
    word44: "グローバルパートナーシップ",
    word45:
      "当社は25以上の大手グローバル銀行およびノンバンクと長期的かつ安定的な関係を確立し、機関投資家向けの流動性とスプレッドを0.0Pipsから提供しています。さらに、金融サービスの枠を超えて、当社はオックスフォード大学との提携、WAGGGSとのパートナーシップ、平等で持続可能な社会を構築するための国連財団への協賛などを通じて、企業の社会的責任を積極的に果たしています。",
    word46: "トップレベルの金融ライセンス",
    word47: "日本不要",
    word48: "日本不要",
    word49: "日本不要",
    word50: "日本不要",
    word51: "ケイマンCIMAによる規制 ",
    word52: "EBC Financial Group (Cayman) Ltd",
    word53: "はケイマン諸島金融庁（CIMA）の認可を受け、規制を遵守しています。",
    word54: "登録番号：2038223",
    word55: "日本不要",
    word56: "日本不要",
    word57: "日本不要",
    word58: "日本不要",
    word59:
      "「EBC Financial Groupの各子会社は厳格な規制の下で事業を運営し、それぞれの管轄区域において最高レベルのライセンスを保有しています。",
    word60:
      "当社は設立当初から、最高水準の規制遵守を堅持し、顧客資産の安全を事業の中核に据えてきました。",
    word61:
      "さらに、大手金融機関とのみ取引を行い、複数の法域における規制枠組みを厳格に遵守し、業界をリードするリスク管理プロトコルを実施しています。セキュリティ、透明性、そしてお客様の信頼を大切にしています。",
    word62: "充実したカスタマーサポート",
    word63:
      "世界中どこでも、いつでも専門度の高いカスタマーサービスをご利用いただけます。",
    word64: "月間平均取引量（米ドル）",
    word65: "登録口座数（2025年8月現在）",
    word66: "取引注文最適化による増益（2025年第2四半期）",
    word67: "進出した国",
    word68: "お問い合わせ",
    word69: "日本チーム",
    word70: "EBCニュース",
    word71: "最新情報、金融スポットライト、専門家の視点をご覧頂けます。",
    word72: "ニュース",
    word73: "パートナー",
    word74: "お問い合わせ",
    word75: "専任の担当者が直接ご連絡いたします。",
    word76: "送信",
    word77: "ロット",
    word78: "ピップス",
    word79: "その他",
    word80: "人気ブローカーTOP10",
    word81: "最も透明性の高いブローカー",
    word82: "最高評価のブローカー",
    word83: "最良執行ブローカー賞",
    word84: "グローバルベストトレーディングエクスペリエンス賞",
    word85: "最も信頼されるFXブローカー賞",
    word86: "ベストCFDブローカー賞",
    word87: "グローバルベストECNブローカー",
    word88: "グローバル新鋭ブローカー",
    word89: "OMAベストブローカー",
    word90: "ベストFX取引プラットフォーム",
    word91: "最優秀取引執行ブローカー",
    word92: "世界ベストのブローカー",
    word93: "お名前",
    word94: "メールアドレス",
    word95: "電話番号",
    word96: "認証コード",
 
};
